import { getRolesAction } from './getRolesAction';

export const rolesActions = {
  getRoles: getRolesAction,
};
